module.exports = __webpack_public_path__ + "assets/font/MiSans-Regular-dd4485f3.woff2";